module.exports = __webpack_public_path__ + "static/img/76.0f46df84.jpg";